import '../scss/main.scss';
// import './core/mixins/mixins';
import 'whatwg-fetch';
import WebFont from 'webfontloader';
import Phaser from 'phaser';
import 'phaser/plugins/spine4.1/dist/SpinePlugin.min';
// import { deepmerge } from 'deepmerge-ts';
import { Bootstrap } from '@scarybeasties/phaser-framework-core';
import { BaseBootConfig } from '@scarybeasties/phaser-framework-core/settings';
import { QueryStringProcessor } from '@scarybeasties/phaser-framework-core/modules';
import { App } from './App';
import { scenes, setupRouting } from './app-routing';
import { sceneIdToSceneMap } from './app-scenes';
import { defaultBootConfig, defaultGameConfig, defaultScaleConfig } from './settings';
import { GameDataHandler } from './game/GameDataHandler';

console.log(`%cIs Production: ${__IS_PRODUCTION__}`, 'background: #000; color: #fff');
console.log(`%cGame version: ${__VERSION__}`, 'background: #000; color: #fff');

export let app: App | undefined;

//#region Load Fonts

// Add fonts to load here!
const fonts: string[] = ["Acme-Regular", "Alegreya", "Lubalin"];
let fontsReady: boolean = fonts.length <= 0;

WebFont.load({
  classes: false,
  custom: {
    families: fonts
  },
  active: () => {
    if (app) app.AssetManager.fontsReady();
    else fontsReady = true;

    console.log('All fonts loaded');
  }
});

//#endregion

// Process query string while waiting for page to load.
const queryPrimaryKey = 'boot';
const querySecondaryKeys = [defaultBootConfig.queryTargetKey, defaultBootConfig.querySceneKey];
let queryStringProcessor = new QueryStringProcessor(queryPrimaryKey, querySecondaryKeys);
queryStringProcessor.processQueryString();

/**
 * Takes the different config sources and merges them down.
 *
 * @param defaultBootConfig
 * @param queryBootConfig
 * @param defaultGameConfig
 * @returns
 */
const buildConfigs = async (defaultBootConfig: BaseBootConfig, queryBootConfig: Partial<BaseBootConfig>, defaultGameConfig: Phaser.Types.Core.GameConfig) => {
  let configFilename = queryBootConfig.configFilename ?? defaultBootConfig.configFilename;
  let configBasePath = queryBootConfig.configBasePath ?? defaultBootConfig.configBasePath;
  const config = await Bootstrap.loadConfig(configBasePath, configFilename);

  let bootConfig: BaseBootConfig = Object.assign({}, defaultBootConfig, config?.bootConfig, queryBootConfig);
  let gameConfig: Phaser.Types.Core.GameConfig = Object.assign({}, defaultGameConfig, config?.gameConfig);
  // let bootConfig: BaseBootConfig = deepmerge(defaultBootConfig, config?.bootConfig, queryBootConfig);
  // let gameConfig: Phaser.Types.Core.GameConfig = deepmerge(defaultGameConfig, config?.gameConfig);

  return { boot: bootConfig, game: gameConfig };
};

const setupGame = async () => {
  let queryBootConfig = queryStringProcessor.getQueryObjectByKey(queryPrimaryKey) ?? {};

  let configs = await buildConfigs(defaultBootConfig, queryBootConfig, defaultGameConfig);

  app = new App(configs.boot, defaultScaleConfig, configs.game);
  if (fontsReady) app.AssetManager.fontsReady();
  const gameDataHandler = new GameDataHandler(app);
  app.init(gameDataHandler, queryStringProcessor);

  setupRouting(app);
  await app.loadLocalisations();
  const generatedSceneList = app.buildSceneList(scenes, sceneIdToSceneMap);

  const game = new Phaser.Game({
    ...app.GameConfig,
    scene: generatedSceneList
  });

  Bootstrap.afterGameCreated(app, game);
  game.scene.start(app.Config.bootScene);
};

window.addEventListener('load', async function () {
  await setupGame();
});
